import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-300">
      {/* Top bar */}
      <header className="border-b border-[#1f1f23] bg-[#0b0b0d]">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors text-sm"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-1.5 h-1.5 bg-emerald-400 rounded-full" />
            <span className="font-heading text-lg tracking-tight text-white">PROX</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1
          className="font-heading text-3xl sm:text-4xl text-white tracking-tight mb-2"
          data-testid="legal-page-title"
        >
          {title}
        </h1>
        {lastUpdated && (
          <p className="font-mono text-xs text-zinc-500 mb-10 tracking-wide uppercase">
            Last updated: {lastUpdated}
          </p>
        )}

        <article className="legal-content space-y-6 text-sm leading-relaxed">
          {children}
        </article>

        {/* Footer links */}
        <footer className="mt-16 pt-8 border-t border-[#1f1f23]">
          <div className="flex flex-wrap gap-6 text-xs text-zinc-500">
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">
              Terms of Service
            </Link>
            <Link to="/sms-terms" className="hover:text-white transition-colors" data-testid="footer-sms-terms">
              SMS Terms
            </Link>
          </div>
          <p className="font-mono text-[10px] text-zinc-600 mt-4">
            Shadow Bridge Technologies, Inc.
          </p>
        </footer>
      </main>
    </div>
  );
}
